import { defineStore } from 'pinia'
import services from '@/services/index';

export const useItemsStore = defineStore('items', {
  state: () => (
    {
      cache: {},
      options: {},
    }),
  getters: {
  },
  actions: {
    setOptions(options) {
      this.options[options.id] = options;
    },
    hasOptions(optionsId) {
      return !!this.options[optionsId];
    },
    getItems(optionsId, cacheId) {
      let options = this.options[optionsId];
      if (!options) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      let cache = this.cache[optionsId];
      if (!cache || !cache[cacheId]) {
        console.warn('Item Store: No Data in Cache', optionsId);
      }

      if (options.idPath) {
        return cache && cache[cacheId] ? Object.values(cache[cacheId]) : [];
      }
      else {
        return cache && cache[cacheId] ? cache[cacheId] : [];
      }
    },
    setItems(optionsId, cacheId, items) {
      let options = this.options[optionsId];
      if (!options) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      this.cache[optionsId] = {};
      if (options.idPath) {
        let map = {};
        items.forEach(i => {
          map[services.helpers.get(i, options.idPath)] = i;
        });
        this.cache[optionsId][cacheId] = map;
      }
      else {
        this.cache[optionsId][cacheId] = items;
      }
    },
    hasItems(optionsId, cacheId) {
      let cache = this.cache[optionsId];
      return cache && cache[cacheId] ? !!cache[cacheId] : false
    },
    getItem(optionsId, cacheId, itemId) {
      let options = this.options[optionsId];
      if (!options) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      if (!options.idPath) {
        console.error('Item Store: No idPath defined', optionsId);
        return;
      }

      let cache = this.cache[optionsId];
      if (!cache || !cache[cacheId]) {
        console.warn('Item Store: No Data in Cache', optionsId);
        return;
      }

      return cache[cacheId][itemId];
    },
    setItem(optionsId, cacheId, item) {
      let options = this.options[optionsId];
      if (!options) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      const idPath = options.idPath;
      if (!idPath) {
        console.warn('Item Store: options.idPath not defined');
        return null;
      }

      const itemId = services.helpers.get(item, idPath);
      let cache = this.cache[optionsId];
      if (!cache || !cache[cacheId]) {
        console.warn('Item Store: Cache not initialized, not adding to cache', optionsId);
        return;
      }

      cache[cacheId][itemId] = item;
    },
    deleteItem(optionsId, cacheId, itemId) {
      let options = this.options[optionsId];
      if (!options) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      let cache = this.cache[optionsId];
      if (!cache || !cache[cacheId]) {
        console.error('Item Store: Store not initialized', optionsId);
        return;
      }

      const idPath = options.idPath;
      if (!idPath) {
        console.warn('Item Store: options.idPath not defined');
        return;
      }

      delete cache[cacheId][itemId];
    },
  },
});
